<div class="rs-flex-column rs-flex-shrink" *ngIf="redirectUrl">
  <p>
    <a href="{{ redirectUrl }}">{{ 'read.mymail.description' | translate }}</a>
  </p>
</div>
